export default "__VITE_ASSET__Hjokddnq__"